module.exports = __webpack_public_path__ + "static/img/tdbig3.490be04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/tdbig3.jpg
// module id = v5KA
// module chunks = 0